import React from "react";
import { Typography, Tag } from "antd";
import trans from "../../../../utils";
import { Alert as AntdAlert } from "antd";

const { Title, Text } = Typography;

const SectionTitle = ({
  title,
  subtitle,
  imgSrc,
  imgWidth = 26,
  imgBgColor = "#E6F4EA",
  filterApplied = false,
  filterText = "",
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        padding: "8px",
        borderRadius: "12px",
        color: "white",
        border: `1px solid #F0F0F0`,
        background: "linear-gradient(135deg, #f8fafc 100%, #ffffff 0%)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: imgBgColor,
            borderRadius: "8px", // makes it a circle
            width: "48px",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginInlineEnd: "16px",
          }}
        >
          {imgSrc && <img src={imgSrc} alt="users" width={imgWidth} />}
        </div>
        <div>
          <Title
            level={4}
            style={{ color: "#000000", margin: 0, fontWeight: "600" }}
          >
            {trans(title)}
          </Title>
          <Text style={{ color: "#42526E73", fontSize: "14px" }}>
            {trans(subtitle)}
          </Text>
        </div>
      </div>

      {filterApplied ? (
        <div>
          <Tag color="blue">{filterText || "Filter Applied Here"}</Tag>
        </div>
      ) : (
        <div>
          <Tag color="green">Not Filtered</Tag>
        </div>
      )}

      {/* Quick Stats - Enhanced like Service Request Dashboard */}
      {/* <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "20px", fontWeight: "700" }}>
              {activeStaff}
            </div>
            <div style={{ fontSize: "12px", opacity: 0.8 }}>
              {trans("Active")}
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "20px", fontWeight: "700" }}>
              {utilizationPercent}%
            </div>
            <div style={{ fontSize: "12px", opacity: 0.8 }}>
              {trans("Busy")}
            </div>
          </div>
        </div> */}
    </div>
  );
};

export default SectionTitle;
